import type { handleRflzResponse, RflzResponseHandlingResult } from './rflzResponseHandler';

const RFLZ_GENERIC_ELIGIBILITY_ERROR =
    'We could not process your eligibility right now. Please verify your details and try again.';

// Keep this normalization browser-independent; the response handler is a type-only dependency.
// A resolved `none` means the response succeeded without a redirect or inline message.
export function resolveRflzEligibilityResult(
    response: Parameters<typeof handleRflzResponse>[0],
    handledResult: RflzResponseHandlingResult,
): RflzResponseHandlingResult {
    if (handledResult.type !== 'none') {
        return handledResult;
    }

    const isSuccessful =
        response.status === 'SUCCESS' && (response.data?.status === undefined || response.data.status === 'SUCCESS');

    return isSuccessful ? handledResult : { type: 'message', message: RFLZ_GENERIC_ELIGIBILITY_ERROR };
}
